import React from 'react'
import Category from './category'
import { changeSelectedCategory } from '../../store/actions'
import { withStore } from '../../context/store.context'

const CategoryContainer = props => (
  <Category
    {...props}
    onClick={() => props.store.dispatch(changeSelectedCategory(props.category))}
  />
)

export default withStore(CategoryContainer)
